
import { Card, CardContent } from "@/components/ui/card";
import { Quote, Play } from "lucide-react";
import { useIntersectionObserver } from "@/hooks/use-intersection-observer";

const TestimonialsSection = () => {
  const { elementRef: titleRef, isVisible: titleVisible } = useIntersectionObserver();
  const { elementRef: cardsRef, isVisible: cardsVisible } = useIntersectionObserver();

  const testimonials = [
    {
      name: "Stéphanie",
      location: "Montpellier",
      quote: "Je me sens accompagnée, soutenue, mais libre d'organiser mes journées. Je n'ai jamais eu ce niveau d'équilibre pro/perso avant.",
      image: "/lovable-uploads/ce0e76d4-a63b-4844-ac1e-3d987cb0e804.png"
    },
    {
      name: "Justine", 
      location: "Lille",
      quote: "En moins de deux mois, j'ai réalisé mes premières missions avec des outils clairs et un vrai réseau derrière moi.",
      image: "/lovable-uploads/justine-profile.png"
    }
  ];

  return (
    <section id="temoignages" className="py-20 gradient-bg-light">
      <div className="container mx-auto px-6">
        <div 
          ref={titleRef}
          className={`text-center mb-16 transition-all duration-800 ${
            titleVisible ? 'animate-slide-in-up' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            💬 <span className="gradient-text">Ils témoignent</span>
          </h2>
        </div>

        <div 
          ref={cardsRef}
          className="grid md:grid-cols-2 gap-8 mb-12 max-w-6xl mx-auto"
        >
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index} 
              className={`group hover:shadow-2xl transition-all duration-500 bg-white/80 backdrop-blur-sm border-0 hover:-translate-y-2 ${
                cardsVisible 
                  ? `animate-slide-in-up animate-stagger-${index + 1}` 
                  : 'opacity-0 translate-y-10'
              }`}
            >
              <CardContent className="p-8">
                <div className="flex items-start mb-6">
                  <Quote className="w-8 h-8 text-primary mr-4 flex-shrink-0 mt-1" />
                  <p className="text-lg text-gray-700 leading-relaxed italic">
                    "{testimonial.quote}"
                  </p>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-4">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                      width="48"
                      height="48"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{testimonial.name}</div>
                    <div className="text-gray-600 text-sm">Indépendante à {testimonial.location}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;
